<template>
  <div class="p-search-history-wrap">
    <div class="p-search-history-list">
      <div class="p-search-history-list_top">
        <div>检索历史</div>
        <div @click="goHistory()">查看历史记录</div>
      </div>

      <ul>
        <li v-for="(history, index) in searchHistoryData" :key="index" @click="goSearchDetail(history)">
          <span v-for="(item, i) in history.queryArray" :key="i">{{(item.name=='keyword'?'全文:':(item.nameDescription || item.nameDes || item.name) +':')+(item.description||item.value)}}</span>
        </li>
        <li v-if="!searchHistoryData.length">无</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PSearchHistory',
  props: {
    searchHistoryData: {
      type: Array,
      default: () => []
    },
    currentType: {
      type: String,
      default: () => 'case'
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    // 清空检索历史
    goHistory () {
      window.open(location.origin + '/#/app/history')
      this.$analysis.track('查看历史记录_工作台入口')
    },
    getQueryFromUrl (url, key) {
      if (typeof url === 'string' && url.includes('#')) {
        const formatUrl = url.split('#').pop()
        if (formatUrl.includes('?')) {
          const query = formatUrl.split('?').pop()
          const usp = new URLSearchParams(query)
          const result = usp.get(key)
          return result
        }
      }
      return ''
    },
    goSearchDetail (history) {
      // 输入框的内容
      const inputvalue = this.getQueryFromUrl(history.url, 'inputvalue')
      // 通知dataBaseSearch.vue组件
      this.$emit('searchHistoryItemClickCallBack')
      // 给工作台页面发送消息，其他跳转操作交给接口消息者
      window.parent.postMessage({
        action: 'fromWorkFlatHistorySearch',
        data: { query: history.text, currentType: this.currentType, inputvalue }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    }
  }
}
</script>
<style lang="stylus" scoped>
.p-search-history-wrap
  width 90%
  margin -1px auto 0
  position relative
  z-index 9
  .p-search-history-list
    padding 15px 0
    overflow hidden
    border-radius 10px
    box-shadow 0 4px 9px 0 rgba(0, 0, 0, 0.1)
    border 1px solid #e5e5e5
    background #fff
    z-index 10
    .p-search-history-list_top
      height 20px
      line-height 20px
      padding 0 10px
      color #a9a9a9
      display flex
      justify-content space-between
      align-items center
      div
        cursor pointer
        &:hover{
          color #ED6C00
        }
    ul
      li
        cursor pointer
        padding 0 10px
        line-height 36px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        &:hover
          background-color #f8f8f9
</style>
